import { render, staticRenderFns } from "./UpgradeModal.vue?vue&type=template&id=4e41be36"
import script from "./UpgradeModal.vue?vue&type=script&lang=ts"
export * from "./UpgradeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports